export enum Page {
  TELEPHONY = 'Telephony',
  CCP = 'Old Panel',
  CHAT = 'Chat',
  EMAIL = 'Email',
  SETTINGS = 'Settings',
  AGENTS_DASHBOARD = 'Agents Dashboard'
}
